import script from "./Master.vue?vue&type=script&setup=true&lang=js"
export * from "./Master.vue?vue&type=script&setup=true&lang=js"

import "./Master.vue?vue&type=style&index=0&id=f78d4afc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f78d4afc"]])

export default __exports__